

export class EmailTemplateListDto implements IEmailTemplateListDto {
    id!: number;
    emailSubject!: string | undefined;
    shortCode!: string | undefined;
    isActive!: boolean;
    templateName!: string | undefined;

    constructor(data?: IEmailTemplateListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.emailSubject = _data["emailSubject"];
            this.shortCode = _data["shortCode"];
            this.isActive = _data["isActive"];
            this.templateName = _data["templateName"];
        }
    }

    static fromJS(data: any): EmailTemplateListDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailTemplateListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["emailSubject"] = this.emailSubject;
        data["shortCode"] = this.shortCode;
        data["isActive"] = this.isActive;
        data["templateName"] = this.templateName;
        return data; 
    }
}

export interface IEmailTemplateListDto {
    id: number;
    emailSubject: string | undefined;
    shortCode: string | undefined;
    isActive: boolean;
    templateName: string | undefined;
}

